const config = {
    notAvailable: 'N/A',
};

export default config;
